// extracted by mini-css-extract-plugin
export default {"container":"percentageBox_container__tD4am","legend":"percentageBox_legend__r2mhh","title":"percentageBox_title__C79KS"};